import React from 'react';
import {
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  List,
  Switch,
  Tooltip,
  Typography
} from '@material-ui/core';
import { Link } from 'react-router-dom';
import { AccountCircle } from '@material-ui/icons';

import Card from '../../../../../components/Card';
import formatDate from '../../../../../helpers/format/formatDate';
import BoldInput from '../../../../../components/inputs/BoldInput';
import ListItem from '../../../../../components/ListItem';
import Setting from './Settings';
import ClientApproval from './ClientApproval';

import ProfileSection from '../../../../../components/ProfileSection';

const ManualEntryCheckbox = ({ values, setFieldValue, fieldName }) => (
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      height: '100%',
      marginTop: 15
    }}
  >
    <FormGroup>
      <FormControlLabel
        control={
          <Switch
            checked={values[fieldName]}
            onChange={() => {
              setFieldValue(fieldName, !values[fieldName]);
            }}
            value={fieldName}
          />
        }
      />
    </FormGroup>
    <Tooltip title="If Manual Entry is selected, Carrier OK will no longer update this field when its data changes.">
      <Typography variant="body1" style={{ fontSize: 12, marginTop: 2 }}>
        Manual Entry
      </Typography>
    </Tooltip>
  </div>
);
export default ({
  values,
  errors,
  handleChange,
  handleBlur,
  setFieldValue,
  paymentProfile,
  paymentProfileId,
  factorCompany = {}
}) => (
  <Card style={{ height: '100%', width: '100%' }}>
    <List dense>
      <ListItem>
        <ProfileSection>Client Info</ProfileSection>
      </ListItem>
      <ListItem>
        <BoldInput
          fullWidth
          name="carrierContactName"
          label="Contact Name"
          disabled
          value={values.carrierContactName}
          onChange={handleChange}
          onBlur={handleBlur}
          error={!!errors.carrierContactName}
          helperText={errors.carrierContactName}
        />
      </ListItem>
      <ListItem>
        <BoldInput
          fullWidth
          name="email"
          label="Email"
          value={values.email}
          onChange={handleChange}
          onBlur={handleBlur}
          error={!!errors.email}
          helperText={errors.email}
        />
      </ListItem>
      <ListItem>
        <BoldInput
          fullWidth
          name="carrierPhone"
          label="Phone"
          disabled
          value={values.carrierPhone}
          onChange={handleChange}
          onBlur={handleBlur}
          error={!!errors.carrierPhone}
          helperText={errors.carrierPhone}
        />
      </ListItem>
      <ListItem>
        <BoldInput
          fullWidth
          name="carrierCreatedAt"
          label="Created At"
          disabled
          value={formatDate(values.carrierCreatedAt)}
          onChange={handleChange}
          onBlur={handleBlur}
          error={!!errors.carrierCreatedAt}
          helperText={errors.carrierCreatedAt}
        />
      </ListItem>
      <ListItem>
        <BoldInput
          fullWidth
          name="carrierLastLogin"
          label="Last Login"
          disabled
          value={formatDate(values.carrierLastLogin)}
          onChange={handleChange}
          onBlur={handleBlur}
          error={!!errors.carrierLastLogin}
          helperText={errors.carrierLastLogin}
        />
      </ListItem>
      {values.businessCurrentFactoringCompany && (
        <ListItem>
          <Grid container direction="row">
            <Grid item xs={10}>
              <BoldInput
                fullWidth
                name="businessCurrentFactoringCompany"
                label="Current Factoring Company:"
                value={values.businessCurrentFactoringCompany}
                disabled
              />
            </Grid>
            <Grid item xs={2} container alignContent="center" justify="center">
              <Tooltip title="View Profile">
                <Link
                  to={`/admin/companies/${values.businessCurrentFactoringCompanyId}/profile`}
                >
                  <IconButton color="primary">
                    <AccountCircle fontSize="large" />
                  </IconButton>
                </Link>
              </Tooltip>
            </Grid>
          </Grid>
        </ListItem>
      )}
      {factorCompany.status &&
      ['declined', 'pending'].includes(factorCompany.status) ? (
        <ListItem>
          <Link to={`/admin/companies/${factorCompany.id}/profile`}>
            <Typography variant="body2">{`Factoring Company Profile is ${factorCompany.status} Status`}</Typography>
          </Link>
        </ListItem>
      ) : null}
    </List>
    <Setting
      setFieldValue={setFieldValue}
      values={values}
      paymentProfile={paymentProfile}
      paymentProfileId={paymentProfileId}
    />
    <ClientApproval setFieldValue={setFieldValue} values={values} />
    <List dense>
      <ListItem>
        <ProfileSection>FMCSA Verified Info For Hubspot</ProfileSection>
      </ListItem>
      <ListItem style={{ display: 'flex', alignItems: 'center' }}>
        <div style={{ flex: 1 }}>
          <BoldInput
            fullWidth
            name="fmcsaPhoneNumber"
            label="FMCSA Verified Phone Number"
            value={values.fmcsaPhoneNumber}
            onChange={handleChange}
            onBlur={handleBlur}
            error={!!errors.fmcsaPhoneNumber}
            helperText={errors.fmcsaPhoneNumber}
          />
        </div>
        <div
          style={{
            marginLeft: 16,
            display: 'flex',
            alignItems: 'center',
            height: '100%'
          }}
        >
          <ManualEntryCheckbox
            values={values}
            setFieldValue={setFieldValue}
            fieldName="fmcsaPhoneNumberManualEntry"
          />
        </div>
      </ListItem>
      <ListItem style={{ display: 'flex', alignItems: 'center' }}>
        <div style={{ flex: 1 }}>
          <BoldInput
            fullWidth
            name="fmcsaCellphoneNumber"
            label="FMCSA Verified Mobile Number"
            value={values.fmcsaCellphoneNumber}
            onChange={handleChange}
            onBlur={handleBlur}
            error={!!errors.fmcsaCellphoneNumber}
            helperText={errors.fmcsaCellphoneNumber}
          />
        </div>
        <div
          style={{
            marginLeft: 16,
            display: 'flex',
            alignItems: 'center',
            height: '100%'
          }}
        >
          <ManualEntryCheckbox
            values={values}
            setFieldValue={setFieldValue}
            fieldName="fmcsaCellphoneNumberManualEntry"
          />
        </div>
      </ListItem>
      <ListItem style={{ display: 'flex', alignItems: 'center' }}>
        <div style={{ flex: 1 }}>
          <BoldInput
            fullWidth
            name="fmcsaEmail"
            label="FMCSA Verified Email"
            value={values.fmcsaEmail}
            onChange={handleChange}
            onBlur={handleBlur}
            error={!!errors.fmcsaEmail}
            helperText={errors.fmcsaEmail}
          />
        </div>
        <div
          style={{
            marginLeft: 16,
            display: 'flex',
            alignItems: 'center',
            height: '100%'
          }}
        >
          <ManualEntryCheckbox
            values={values}
            setFieldValue={setFieldValue}
            fieldName="fmcsaEmailManualEntry"
          />
        </div>
      </ListItem>
    </List>
  </Card>
);
